import { Primitive } from "../Primitive/Primitive.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/Calendar/CalendarHeader.vue?vue&type=script&setup=true&lang.ts
var CalendarHeader_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "CalendarHeader",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false,
			default: "div"
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Primitive), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/Calendar/CalendarHeader.vue
var CalendarHeader_default = CalendarHeader_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { CalendarHeader_default };
//# sourceMappingURL=CalendarHeader.js.map